<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      ripple
      height="100%"
      :class="[hover ? 'elevation-24' : 'elevation-2', 'clickable']"
      @click="actionOnTileClick ? actionOnTileClick() : () => {}"
    >
      <v-layout column fill-height justify-space-between class="ma-0">
        <v-flex shrink class="pa-0">
          <v-img v-if="imgsrc" :src="imgsrc" aspect-ratio="2" />
          <v-card-title>
            <div>
              <div class="headline secondary--text">
                {{ title }}
              </div>
              <div :class="[lineClamp ? 'line-clamp' : '']">
                {{ description }}
              </div>
            </div>
          </v-card-title>
        </v-flex>
        <v-flex shrink class="pa-0">
          <v-btn
            v-if="buttonText"
            depressed
            large
            block
            color="primary"
            class="ma-0 fma-block-button"
            @click="buttonAction ? buttonAction() : () => {}"
          >
            {{ buttonText }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  props: {
    // TODO: fix this stuff down here for eslint
    /* title text */
    title: {
      type: String,
      default: ""
    },
    /* description text */
    description: {
      type: String,
      default: "No Description Available"
    },
    /* source of the image to be displayed
        if not specified, then no image is displayed */
    imgsrc: {
      type: String,
      default: ""
    },
    /* text to display on the button
        only has an effect if a value is provided for buttonAction */
    buttonText: {
      type: String,
      default: ""
    },
    /* function to be executed when button is clicked
        if not specified, then no button is displayed */
    buttonAction: {
      type: Function,
      default: () => {}
    },
    /* function to be executed when tile is clicked */
    actionOnTileClick: {
      type: Function,
      default: () => {}
    },
    /* limit description text to 3 lines */
    lineClamp: Boolean
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

/* fallback to fading text out if -webkit-line-clamp isn't supported */
.line-clamp {
  position: relative;
  height: 4.5em; /* exactly three lines */
  line-height: 1.5em;
  overflow: hidden;
}
.line-clamp:after {
  content: "";
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  height: 1.5em;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
}

/* if -webkit-line-clamp is supported, limit text to 3 lines and end with ellipsis */
@supports (-webkit-line-clamp: 3) {
  .line-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    max-height: 4.5em;
    height: auto;
  }
  .line-clamp:after {
    display: none;
  }
}
</style>
